import { setSelectedStudent } from '../../redux/Slices/ResultsSlice/ResultsSlice';
import { useAppDispatch, useAppSelector } from '../../redux/store/hooks';
import { useGetAllStudentsQuery } from '../../services/CoOrdinatorApi/coOrdinatorApi';
import Dropdown from '../Common/Dropdown';

export type selectedStudent = {
  id: string;
  name: string;
};

const StudentsDropDown = () => {
  const { data: studentsData } = useGetAllStudentsQuery(
    {},
    { refetchOnMountOrArgChange: true }
  );
  const { selectedStudent } = useAppSelector(state => state.root.results);
  const dispatch = useAppDispatch();

  return (
    <div className='z-[999]'>
      <Dropdown
        options={studentsData?.data ?? [{ topicName: 'No Students Found' }]}
        getOption={(each: any) => each?.name}
        handleDropdownChange={e => {
          dispatch(setSelectedStudent(e));
        }}
        value={selectedStudent?.name}
        placeholder='Select a Student'
        width='w-50'
        classes='border border-beta bg-alpha shadow-boxShadowOne'
      />
    </div>
  );
};

export default StudentsDropDown;
